<div class="nls-validation-container">
  <div class="header-row">
    <h2 class="page-title">NLS Customer Validation</h2>
    <div class="summary" *ngIf="!isLoading">
      <span class="summary__item summary__item--valid">
        <mat-icon>check_circle</mat-icon>
        {{ validCount | number }} valid
      </span>
      <span class="summary__item summary__item--incomplete">
        <mat-icon>warning</mat-icon>
        {{ incompleteCount | number }} incomplete
      </span>
    </div>
  </div>

  <p class="page-subtitle">
    Open loans with missing customer information, no bank account, or a transit and
    institution number that is not in the FIF branch list.
  </p>

  <mat-card class="content-card">
    <mat-card-content>
      <div class="filters-row">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [formControl]="searchControl" placeholder="Loan number, first or last name" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="status-field">
          <mat-label>Status</mat-label>
          <mat-select [formControl]="statusFilter">
            <mat-option value="incomplete">Missing info only</mat-option>
            <mat-option value="all">All customers</mat-option>
            <mat-option value="valid">Complete only</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="table-area">
        <div *ngIf="isLoading" class="loading-overlay">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <table mat-table [dataSource]="customers" [trackBy]="trackByAcctrefno" class="flat-table">
          <ng-container matColumnDef="loanNumber">
            <th mat-header-cell *matHeaderCellDef>Loan #</th>
            <td mat-cell *matCellDef="let row">{{ row.loanNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef>Customer Name</th>
            <td mat-cell *matCellDef="let row">
              <div class="stacked-cell">
                <span>{{ row.customerName }}</span>
                <span *ngIf="nameIssues(row).length" class="field-missing">
                  Missing {{ nameIssues(row).join(', ') }}
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let row">
              <span *ngIf="row.email; else missingCell">{{ row.email }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Phone</th>
            <td mat-cell *matCellDef="let row">
              <span *ngIf="row.phone; else missingCell">{{ row.phone }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>Address</th>
            <td mat-cell *matCellDef="let row">
              <div class="stacked-cell">
                <span>{{ formatAddress(row) }}</span>
                <span *ngIf="addressIssues(row).length" class="field-missing">
                  Missing {{ addressIssues(row).join(', ') }}
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="bankAccount">
            <th mat-header-cell *matHeaderCellDef>Bank Account</th>
            <td mat-cell *matCellDef="let row">
              <div class="bank-cell">
                <ng-container *ngIf="row.hasBankAccount; else noAccount">
                  <span class="bank-cell__account">
                    {{ row.institutionCode }}-{{ row.transitNumber }}
                    <span class="bank-cell__number">{{ row.accountNumberMasked }}</span>
                  </span>
                  <span *ngIf="row.branchName" class="bank-cell__branch">{{ row.branchName }}</span>
                </ng-container>
                <ng-template #noAccount>
                  <span class="field-missing">No bank account</span>
                </ng-template>

                <mat-chip-set *ngIf="bankIssues(row).length > 0">
                  <mat-chip *ngFor="let issue of bankIssues(row)" class="missing-chip">
                    {{ issue }}
                  </mat-chip>
                </mat-chip-set>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <div *ngIf="!isLoading && customers.length === 0" class="empty-state">
          {{ emptyStateMessage }}
        </div>
      </div>

      <mat-paginator
        [length]="rowCount"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPage($event)"
        showFirstLastButtons>
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #missingCell>
  <span class="field-missing">Missing</span>
</ng-template>
